/* eslint-disable eqeqeq */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
import {
  // WEBSOCKET_SEND,
  // WEBSOCKET_CONNECT,
  // disconnect,
  connect,
  send,
} from '@giantmachines/redux-websocket';
import uuidv4 from 'uuid';
import {
  WEBSOCKET_PREFIX, CUSTOMER_RESERVED_WORDS,
  DIALOG,
  STATUS,
  STORAGE_KEY,
} from 'shared/constants';
import englishMessages from 'shared/translations/en.json';
import arabMessages from 'shared/translations/ar.json';
// import constructApiUri from 'shared/util/ApiBaseUri';
import { ACTION_TYPE } from 'shared/redux/actions/actionTypes';
import api from 'shared/services/api';

const webSocketUrl = process.env.REACT_APP_API_URL;

/**
 * CONVERSATION ACTION
 */
export const createConversation = () => (dispatch, getState) => new Promise((resolve) => {
  const { userInfo } = getState().rootReducer;
  const dialog = window.location.pathname.split('/')[1];
  const body = {
    user: userInfo._id,
    session: userInfo.uuid,
    dialog,
  };
  api.createConversation(body, userInfo)
    .then(() => {
      dispatch({
        type: ACTION_TYPE.CLEAR_CONVERSATION_HISTORY,
        payload: {
          stopThread: null,
          vars: null,
        },
      });
      resolve();
    })
    .catch((err) => {
      console.log(err);
    });
});

export const getSavedConversation = () => (dispatch, getState) => new Promise((resolve) => {
  const { userInfo } = getState().rootReducer;
  const dialog = window.location.pathname.split('/')[1];

  api.getConversation(userInfo)
    .then((res) => {
      if (res.success) {
        const convo = res.results.filter(att => att.dialog === dialog);
        let type;
        if (dialog === DIALOG.INVESTOR_PROFILE) {
          type = ACTION_TYPE.GET_SAVED_INVESTOR_PROFILE;
        } else if (dialog === DIALOG.RISK_ASSESSMENT) {
          type = ACTION_TYPE.GET_SAVED_RISK_ASSESSMENT;
        } else if (dialog === DIALOG.INVESTMENT_PREFERENCE) {
          type = ACTION_TYPE.GET_SAVED_INVESTMENT_PREFERENCE;
        }

        const conversation = convo[0] ? convo[0].conversations : [];
        const stopThread = convo[0] ? convo[0].stopThread : null;
        const vars = convo[0] ? convo[0].vars : null;

        dispatch({
          type,
          payload: {
            conversation,
            stopThread,
            vars,
          },
        });
        resolve(stopThread);
      }
    })
    .catch((err) => {
      console.log(err);
    });
});

export const updateConversation = rootReducer => new Promise((resolve) => {
  const {
    userInfo,
    PreInvestorProfile,
    PreRiskAssessment,
    PreInvestmentPreference,
    // PreCallToAction,
  } = rootReducer;

  const dialog = window.location.pathname.split('/')[1];

  const body = {};

  if (dialog === DIALOG.INVESTOR_PROFILE) {
    body.conversations = PreInvestorProfile;
  } else if (dialog === DIALOG.RISK_ASSESSMENT) {
    body.conversations = PreRiskAssessment;
  } else if (dialog === DIALOG.INVESTMENT_PREFERENCE) {
    body.conversations = PreInvestmentPreference;
  }

  if (dialog !== DIALOG.CALL_TO_ACTION) {
    // excluding conversation inside each user answer, hello/quit message
    body.conversations = body.conversations.filter((att) => {
      delete att.conversations;
      if (att.text === 'hello' || att.text === 'quit'
      ) {
        return false;
      }
      return true;
    });
    if (body.conversations.length) {
      api.updateConversation(userInfo, dialog, body)
        .then(() => {
          resolve();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
});

export const clearConversationHistory = () => (dispatch, getState) => new Promise((resolve) => {
  const {
    userInfo,
  } = getState().rootReducer;
  const dialog = window.location.pathname.split('/')[1];
  dispatch(generateChannel());
  api.clearConversationHistory(userInfo, dialog).then((res) => {
    if (res.success) {
      dispatch({
        type: ACTION_TYPE.CLEAR_CONVERSATION_HISTORY,
        payload: {
          stopThread: null,
          vars: null,
          redo: dialog !== DIALOG.CALL_TO_ACTION ? dialog : '',
          dialog,
        },
      });
      resolve();
    } else if (dialog === DIALOG.CALL_TO_ACTION) {
      // if the conversation is not exist then create a new one
      createConversation(userInfo, dialog)
        .then(() => {
          resolve();
        });
    }
  }).catch(err => console.log(err));
});

export const websocketSend = (message, option = 'nothing', dialog = '') => async (dispatch, getState) => {
  const body = {
    dialog: dialog === '' ? window.location.pathname.split('/')[1] : dialog,
    customer: true,
    text: message,
    type: 'message',
    stopThread: getState().rootReducer.stopThread,
    vars: getState().rootReducer.vars,
    option,
    user: getState().rootReducer.user,
    userInfo: getState().rootReducer.userInfo,
    channel: 'socket',
    typingDelay: CUSTOMER_RESERVED_WORDS.includes(message) ? 0 : 1500,
  };

  // this promise ensure to get the latest conversation before sending message
  new Promise((resolve) => {
    dispatch({
      type: ACTION_TYPE.PRE_MESSAGE_SEND,
      payload: {
        ...body,
      },
    });
    resolve({ rootReducer: getState().rootReducer, message });
  })
    .then((resolved) => {
      if (resolved && resolved.message && resolved.message != 'hello' && resolved.message != 'restart') {
        updateConversation(resolved.rootReducer);
      }
      // send message
      dispatch(send({
        ...body,
      }, WEBSOCKET_PREFIX));
    });
};

export const clearConversationsStack = () => ({
  type: ACTION_TYPE.CLEAR_CONVERSATION,
});

export const websocketConnect = () => (dispatch) => {
  dispatch(connect(webSocketUrl, WEBSOCKET_PREFIX));
};

export const submitReply = (reply, option, dialog) => (dispatch) => {
  dispatch(websocketSend(reply, option, dialog));
};

export const switchLanguage = id => (dispatch) => {
  const languages = {
    EN: englishMessages,
    AR: arabMessages,
  };

  const payload = { language: { locale: id, messages: languages[id] } };
  dispatch({
    type: 'SWITCH_LANGUAGE',
    payload,
  });
};

export const toggleLanguage = () => (dispatch, getState) => {
  const languages = {
    EN: englishMessages,
    AR: arabMessages,
  };
  const { language } = getState().rootReducer;
  let id;
  if (language.locale === 'EN') {
    id = 'AR';
  } else {
    id = 'EN';
  }

  const payload = { language: { locale: id, messages: languages[id] } };
  dispatch({
    type: 'SWITCH_LANGUAGE',
    payload,
  });
};

export const resetBotTyping = () => ({
  type: 'RESET_BOT_TYPING',
});

export const updateSummary = object => ({
  type: ACTION_TYPE.UPDATE_SUMMARY,
  payload: object,
});

export const generateChannel = () => (dispatch) => {
  dispatch({
    type: ACTION_TYPE.GENERATE_CHANNEL,
    payload: uuidv4(),
  });
};

/**
 * STEP ACTION
 */
export const getStepStatus = () => (dispatch, getState) => new Promise((resolve) => {
  const { userInfo, stepStatus, redo } = getState().rootReducer;
  let stepStatusAvatar = [...stepStatus];

  api.getStep(userInfo)
    .then((res) => {
      const { steps, user } = res.results;
      // update user information to store
      dispatch({
        type: ACTION_TYPE.SAVE_USER_INFO,
        payload: user,
      });

      // update redo state when a step completed
      const theStep = steps.find(att => att.dialog === redo);
      if (theStep && theStep.status === STATUS.COMPLETED) {
        dispatch({
          type: ACTION_TYPE.SET_REDO,
          payload: '',
        });
      }

      // update step status to store
      stepStatusAvatar = stepStatusAvatar.map((value, i) => {
        const it = steps.find(att => att.dialog === stepStatusAvatar[i].step);
        if (it) {
          return { ...value, active: it.active, status: it.status };
        }
        return { ...value };
      });
      dispatch({
        type: ACTION_TYPE.SAVE_STEP_STATUS,
        payload: stepStatusAvatar,
      });

      resolve(true);
    })
    .catch((err) => {
      console.log(err);
    });
});

export const createStep = userInfo => new Promise((resolve) => {
  const steps = [{
    dialog: DIALOG.INVESTOR_PROFILE,
    active: true,
    status: null,
  }, {
    dialog: DIALOG.RISK_ASSESSMENT,
    active: false,
    status: null,
  }, {
    dialog: DIALOG.INVESTMENT_PREFERENCE,
    active: false,
    status: null,
  }];

  api.createStep(userInfo, steps)
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
});

export const updateStep = status => (dispatch, getState) => new Promise((resolve) => {
  const dialog = window.location.pathname.split('/')[1];
  const { userInfo } = getState().rootReducer;

  api.updateStep(userInfo, dialog, status)
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
});

/** */

/**
 * USER ACTION
 */
export const registerAccount = () => dispatch => new Promise((resolve) => {
  const uuid = uuidv4();
  // register a new account
  api.userRegistation(uuid)
    .then((res) => {
      if (res.success) {
        dispatch({
          type: ACTION_TYPE.SAVE_USER_INFO,
          payload: res.results,
        });
        localStorage.setItem(STORAGE_KEY.EXPIRATION_DATE, new Date().getTime());
        // create new step after registration successfully
        createStep(res.results);
        resolve(res.results);
      }
    })
    .catch((err) => {
      console.log(err);
    });
});
/** */

export const saveUserRating = rating => (dispatch, getState) => {
  const { userInfo } = getState().rootReducer;
  // const body = {
  // rating,
  // };
  // return api.updateUser(userInfo, body).then((res) => {
  dispatch({
    type: ACTION_TYPE.SAVE_USER_INFO,
    payload: {
      ...userInfo,
      rating,
    },
  });
  // }).catch(err => console.log(err));
};


export const activateStartStep = () => (dispatch, getState) => {
  const { isStartStep } = getState().rootReducer;
  if (!isStartStep) {
    dispatch({ type: ACTION_TYPE.ACTIVATE_START_STEP });
  }
};

export const refreshApp = () => async (dispatch, getState) => {
  const { userInfo } = getState().rootReducer;

  const resetConvo = await api.resetConversation(userInfo);
  const resetStep = await api.resetStep(userInfo);
  const resetUser = await api.resetUser(userInfo);

  await Promise.all([
    resetConvo,
    resetStep,
    resetUser,
  ]);
};
